import React from "react";

import { Form } from "@weezevent/nacre";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

/**
 * This component is an input to manage a toggle (switch) value.
 * It's a controlled field that deals with react-hook-form. Must be wrapped by a FormContext.
 */
const FormFieldToggle = ({
	name,
	label,
	control,
	onChange: onExternalChange,
	...props
}) => {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useController({
		name: name,
		control
	});

	const onChangeValue = React.useCallback(
		e => {
			onChange(e.target.checked);
			onExternalChange(e.target.checked);
		},
		[onChange, onExternalChange]
	);

	return (
		<Form.ToggleLabel
			name={name}
			label={label}
			value={value}
			onChange={onChangeValue}
			errors={!!error}
			{...props}
		/>
	);
};

FormFieldToggle.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	control: PropTypes.object,
	onChange: PropTypes.func
};

FormFieldToggle.defaultProps = {
	label: "",
	control: {},
	onChange: () => {}
};

export default FormFieldToggle;
